import { useMemo } from 'react';

import { useRelevancyFeed } from '../model';
import { useRelevancyOptions } from '../store';

import { IS_DEBUG } from '@utilities/browser';

export const useItemsToShow = () => {
  const { feed } = useRelevancyFeed();
  const { options } = useRelevancyOptions();
  const hiddenItems = useMemo(() => feed.filter((item) => item.hidden).length, [feed]);

  const itemsToShow = useMemo(
    () =>
      feed
        .filter((item) => !item.error || IS_DEBUG)
        .filter(
          (_, index) =>
            (!!options.testRelevanceUrl && IS_DEBUG) ||
            options.infiniteScroll ||
            index < options.cardsNumber + hiddenItems,
        ),
    [feed, hiddenItems, options.cardsNumber, options.infiniteScroll, options.testRelevanceUrl],
  );

  return { itemsToShow };
};
